import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import classNames from 'classnames';
import React, { ReactNode, PropsWithChildren } from 'react';

interface MenuItem {
  label: ReactNode;
  action?: () => void;
  header?: boolean;
}

interface DropdownMenuProps {
  items: MenuItem[];
}

export default function DropdownMenu({
  children,
  items,
}: PropsWithChildren<DropdownMenuProps>) {
  return (
    <div className="relative inline-block text-left">
      <DropdownMenuPrimitive.Root>
        <DropdownMenuPrimitive.Trigger asChild>
          {children}
        </DropdownMenuPrimitive.Trigger>

        <DropdownMenuPrimitive.Portal>
          <DropdownMenuPrimitive.Content
            align="end"
            sideOffset={5}
            className={classNames(
              'popover-content-right',
              'w-48 overflow-hidden rounded-lg shadow-md md:w-56',
              'bg-white dark:bg-brand-dark-50',
              'z-20 ring-1 ring-inset ring-brand-dark-50/5 dark:ring-brand-light-15',
            )}
          >
            {items.map(({ label, action, header = false }, i) =>
              header ? (
                <DropdownMenuPrimitive.Label
                  key={'label-' + i}
                  className="select-none px-2 py-3 text-center text-sm text-gray-700 dark:text-brand-light-25"
                >
                  {label}
                </DropdownMenuPrimitive.Label>
              ) : (
                <DropdownMenuPrimitive.Item
                  key={'dropdown-item-' + i}
                  onClick={action}
                  className={classNames(
                    'flex cursor-pointer select-none items-center px-4 py-2 text-xs outline-none',
                    'text-brand-100 focus:bg-gray-50 dark:text-brand-light-100 dark:focus:bg-brand-dark-25',
                  )}
                >
                  {label}
                </DropdownMenuPrimitive.Item>
              ),
            )}
          </DropdownMenuPrimitive.Content>
        </DropdownMenuPrimitive.Portal>
      </DropdownMenuPrimitive.Root>
    </div>
  );
}
